import { createAppI18n } from '../../../shared/setup-i18n'

const i18n = createAppI18n('commonHeader')

function getDefaultHeaderLeft() {
  const { t } = i18n.global
  return [
    { id: 'discoverProducts', visible: true, label: t('discoverProducts') },
    { id: 'pricing', visible: true, label: t('pricing') }
  ]
}

export function normalizeHeader(raw) {
  if (!raw || typeof raw !== 'object') {
    return {
      style: {},
      customs: { left: getDefaultHeaderLeft(), right: [] },
      isDefault: true
    }
  }
  const payload = raw.customsPayload ?? raw
  const customs = payload?.customs ?? {}
  return {
    style: payload?.style ?? raw?.style ?? {},
    customs: {
      left: Array.isArray(customs.items) ? customs.items : []
      // right: Array.isArray(customs.right) ? customs.right : []
    },
    logo: raw.logo,
    isDefault: false
  }
}
